module.exports = __webpack_public_path__ + "img/download-24px.1f8f0d5f.svg";